export default __webpack_public_path__ + "static/media/ico_user.2f6125ec.png";